import React from 'react';
import {
    ColumnDef,
} from '@tanstack/react-table';
import { IFormattedCashFlowPeriod } from 'views/ProFormaTable/types';
import RenderIf from 'components/RenderIf/RenderIf';
import { IncomeCalculationType } from 'constants/proForma';
import FloorAllocationsTable from './FloorAllocationsTable/FloorAllocationsTable';
import EstimateRecoveryTable from './EstimateRecoveryTable/EstimateRecoveryTable';
import TenantsTable from './TenantsTable/TenantsTable';
import TenantsRecoveryTable from './TenantsRecoveryTable/TenantsRecoveryTable';
import OtherIncomeTable from '../commonTables/OtherIncomeTable/OtherIncomeTable';
import TotalPotentialIncomeTable from '../commonTables/TotalPotentialIncomeTable/TotalPotentialIncomeTable';
import IncomeAdjustmentsTable from '../commonTables/IncomeAdjustmentsTable/IncomeAdjustmentsTable';
import { useProFormaSocketContext } from '../../../socketContext/ProFormaSocketProvider';

export interface IRetailOfficeIndustrialIncomeProps {
    operationBeginIndex: number;
    baseCashFlowColumns: ColumnDef<any>[];
    monthlyPeriodOptions: IFormattedCashFlowPeriod[];
}

const RetailOfficeIndustrialIncome = ({
    operationBeginIndex,
    baseCashFlowColumns,
    monthlyPeriodOptions,
}: IRetailOfficeIndustrialIncomeProps) => {
    const { operatingInfo } = useProFormaSocketContext();

    return (
        <>
            <RenderIf isTrue={operatingInfo.incomeCalculationType === IncomeCalculationType.TENANTS}>
                <TenantsTable
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                    monthlyPeriodOptions={monthlyPeriodOptions}
                />
                <TenantsRecoveryTable
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                    monthlyPeriodOptions={monthlyPeriodOptions}
                />
            </RenderIf>
            <RenderIf isTrue={operatingInfo.incomeCalculationType !== IncomeCalculationType.TENANTS}>
                <FloorAllocationsTable
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                />
                <EstimateRecoveryTable
                    operationBeginIndex={operationBeginIndex}
                    baseCashFlowColumns={baseCashFlowColumns}
                    monthlyPeriodOptions={monthlyPeriodOptions}
                />
            </RenderIf>
            <OtherIncomeTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
                monthlyPeriodOptions={monthlyPeriodOptions}
            />
            <TotalPotentialIncomeTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
            <IncomeAdjustmentsTable
                operationBeginIndex={operationBeginIndex}
                baseCashFlowColumns={baseCashFlowColumns}
            />
        </>
    );
};

export default RetailOfficeIndustrialIncome;
